var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import { SubSink } from "subsink";
import { subjectsComplete } from "../../common/app.helpers";
var UnsubscribeOnDestroyAbsctractClass = /** @class */ (function () {
    function UnsubscribeOnDestroyAbsctractClass() {
        this.subs = new SubSink();
        this.subjects$ = [];
    }
    UnsubscribeOnDestroyAbsctractClass.prototype.ngOnDestroy = function () {
        this.subs.unsubscribe();
        subjectsComplete(this.subjects$);
    };
    UnsubscribeOnDestroyAbsctractClass.prototype.trackSubscription = function (subscription) { this.subs.add(subscription); };
    UnsubscribeOnDestroyAbsctractClass.prototype.trackSubscriptions = function () {
        var subscriptions = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            subscriptions[_i] = arguments[_i];
        }
        var _a;
        (_a = this.subs).add.apply(_a, __spread(subscriptions));
    };
    return UnsubscribeOnDestroyAbsctractClass;
}());
export { UnsubscribeOnDestroyAbsctractClass };
